export const SKILL_213_CODE = '213';
export const TEAME_183_FLAG_ID = 'TEAME-183-skill-213-update';

/** The arm that gets the rebuilt skill 213. Everyone else, control included, gets the baseline. */
export const TEAME_183_TREATMENT = 'treatment';
export const TEAME_183_DATA_PERSISTENCE_VARIANT = 'default';
export const CHALLENGE_PASSING_SCORE = 8;
export const TEAME_183_SIDEBAR_MIN_WIDTH_PX = 320;
export const TEAME_183_SIDEBAR_MAX_WIDTH_PX = 400;
export const TEAME_183_SIDEBAR_WIDTH_PERCENT = 28;
export const TEAME_183_MAIN_VIEWPORT_MIN_WIDTH_PX = 720;
export const TEAME_183_MAIN_VIEWPORT_MIN_HEIGHT_PX = 540;

export interface Skill213LoggingData {
  firstAccessTimestamp: number | null;
  minutesToPass: number | null;
}

export const DEFAULT_SKILL_213_LOGGING_DATA: Skill213LoggingData = {
  firstAccessTimestamp: null,
  minutesToPass: null,
};
